<template>
  <div class="invite-code-input">
    <input
      class="invite-code-input__field typo-body-m-medium"
      type="text"
      :value="value"
      placeholder="초대 코드를 입력해 주세요."
      maxlength="8"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    />
    <span
      class="invite-code-input__message typo-caption-xs-medium"
      :class="{ 'invite-code-input__message--error': hasError }"
    >{{ disabled ? completedMessage : message }}</span>
  </div>
</template>

<script>
export default {
  name: 'InviteCodeInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rewardStatus: {
      type: String,
      default: '',
    },
    notEligible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    completedMessage() {
      if (this.notEligible) {
        return '이벤트 대상이 아니예요.';
      }
      if (this.rewardStatus === 'REWARDED') {
        return '이벤트 상품이 지급된 추천인 코드입니다.';
      }
      if (this.rewardStatus === 'EXPIRED') {
        return '추천인 등록 후 100일이 지나 이벤트 대상에서 제외되었습니다.';
      }
      if (this.rewardStatus === 'REGISTERED') {
        return '초대코드가 정상적으로 등록되었습니다.';
      }
      if (this.rewardStatus === 'PURCHASED') {
        return '';
      }
      return '완료 된 초대코드예요.';
    },
  },
}
</script>

<style scoped>
.invite-code-input {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
}

.invite-code-input__field {
  display: flex;
  height: 48px;
  padding: 0 16px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--color-divider-200, #E5E8EB);
  background: #FFF;
  box-sizing: border-box;
  outline: none;
  color: var(--color-text-main, #191F28);
}

.invite-code-input__field::placeholder {
  color: var(--color-text-normal, #B0B8C1);
}

.invite-code-input__field:disabled {
  background: var(--color-bg-disabled, #F2F4F6);
  color: var(--color-text-disabled, #B0B8C1);
  cursor: not-allowed;
}

.invite-code-input__field:focus {
  border: 2px solid var(--blue-50, #06F);
  background: var(--common-100, #FFF);
}

.invite-code-input__message {
  color: var(--color-text-sub, #6B7684);
}

.invite-code-input__message--error {
  color: var(--color-text-warning, #F04452);
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/InviteCodeInput.vue